import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const depositList = createAsyncThunk(
  "depositList",
  async (payload, thunkAPI) => {
    try {
    
      const response = await api.get("deposit");
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const depositListSlice = createSlice({
  name: "depositList",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(depositList.pending, (state) => {
        state.loading = true;
      })
      .addCase(depositList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(depositList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default depositListSlice.reducer;
